import { Link } from "react-router-dom";
import { Badges, P, SVG } from "../../../AbstractElements";
import { Href } from "../../../utils/Constant";
// import { Rating } from "react-simple-star-rating";
// import { dynamicImage } from "../../../Service";
import { TableColumn } from "react-data-table-component";
import { LockerListTableDataColumnType, LockerListTableOffer } from "../../../Types/Application/Ecommerce/Ecommerce";
import Swal from "sweetalert2";
import api from "../../../utils/api";

export const LockerListTableData = [
    {
        "lockerId": 1,
        "lockerNumber": 1,
        "lockerType": "Big Locker",
        "lockerPrice": 200.00,
        "securityCharges": 56,
        "isLocked": false
    },
    {
        "lockerId": 2,
        "lockerNumber": 1,
        "lockerType": "Small Locker",
        "lockerPrice": 100.00,
        "securityCharges": 10,
        "isLocked": false
    },
    {
        "lockerId": 3,
        "lockerNumber": 2,
        "lockerType": "Big Locker",
        "lockerPrice": 200.00,
        "securityCharges": 10,
        "isLocked": false
    },
    {
        "lockerId": 4,
        "lockerNumber": 2,
        "lockerType": "Small Locker",
        "lockerPrice": 100.00,
        "securityCharges": 10,
        "isLocked": false
    }
];

// const ClothListTableAction = () => {
//   return (
//     <div className="product-action">
//       <Link to={Href}>
//         <SVG iconId="edit-content" style={{ fill: 'blue' }} />
//       </Link>
//       <SVG iconId="trash1" style={{ fill: 'red' }}/>
//     </div>
//   );
// };

const handleDelete = async (id: number) => {
  try {
    await api.delete(`/api/LockerMaster/DeleteLocker?lockerId=${id}`);
    Swal.fire('Deleted!', 'Locker has been deleted.', 'success');

    // Optional: refresh the list
    // setTicketListTableDatas((prev) => prev.filter((item) => item.adultPlanId !== id));
  } catch (error) {
    Swal.fire('Error!', 'Failed to delete the locker.', 'error');
    console.error("Delete error:", error);
  }
};

interface ProductListTableActionProps {
  lockerId: any;
  onDelete: (id: number) => void;
}

export const LockerListTableAction: React.FC<ProductListTableActionProps> = ({ lockerId, onDelete }) => {
  const editUrl = `/locker/edit/${lockerId}`;

  const handleDeleteClick = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this ticket plan!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.isConfirmed) {
        onDelete(lockerId);
      }
    });
  };

  return (
    <div className="product-action d-flex gap-2">
      <Link to={editUrl}>
        <SVG iconId="edit-content" style={{ fill: 'blue' }} />
      </Link>
      <button className="btn btn-sm" onClick={handleDeleteClick}>
        <SVG iconId="trash1" style={{ fill: 'red' }} />
      </button>
    </div>
  );
};

export const LockerListTableOfferComponent: React.FC<LockerListTableOffer> = ({ title }) => {
  return (
    <div className="product-names my-2">
      <P>{title}</P>
    </div>
  );
};

export const LockerListTableStatus :React.FC<LockerListTableOffer> = ({ title }) => {
  return (
    <Badges color="" className={`badge-light-${title === "Active" ? "secondary" : "primary" }`}>{title}</Badges>
  );
};

export const LockerListTableDataColumn: TableColumn<LockerListTableDataColumnType>[] = [
  {
    name: "Locker Number",
    cell: (row) => <LockerListTableOfferComponent title={row.lockerNumber}/>,
    sortable: true,
    grow: 2,
  },
  {
    name: "Locker Size",
    cell: (row) => <LockerListTableOfferComponent title={row.lockerType}/>,
    sortable: true,
    grow: 2,
  },
  {
    name: "Locker Price",
    cell: (row) => <LockerListTableOfferComponent title={String(row.lockerPrice)}/>,
    sortable: true,
    grow: 2,
  },
  {
    name: "Security Charge",
    cell: (row) => (
      <LockerListTableOfferComponent title={String(row.securityCharges)} />
    ),
    sortable: true,
    grow: 2,
    minWidth: '100px',
  },
  {
    name: "Action",
    cell: (row) => <LockerListTableAction lockerId={row.lockerId} onDelete={handleDelete} />,
  },
];

  export const filtersData = [
    {
      name: "Choose Cloth Number",
      options: ["101", "102"],
    },
    {
      name: "Status",
      options: ["Active", "Inactive"],
    },
  ];